import {
    LogNotification,
    LogNotifyBroadcast,
    LogNotifyGame,
    LogNotifyPayment,
    LogNotifyTournament,
    LogNotifyType,
} from '@/api';

type NotificationStreamPayload = {
    id?: string;
    user_id?: string | null;
    parent_id?: string;
    type?: LogNotifyType;
    sub_type?: string;
    message_fallback?: string;
    message_data?: Record<string, string>;
    internal?: boolean;
    published_at?: string | null;
    read_at?: string | null;
};

const normalizeTimestamp = (value?: string | null) => {
    if (!value) return;
    if (/(?:Z|[+-]\d{2}:?\d{2})$/i.test(value)) return value;
    return `${value}Z`;
};

export const parseNotificationEvent = (data: string): LogNotification | undefined => {
    try {
        const payload = JSON.parse(data) as NotificationStreamPayload;
        if (!payload.id || !payload.type) return;

        return {
            id: payload.id,
            // The SSE payload uses null for anonymous events, while the generated API type currently omits null.
            userId: payload.user_id as LogNotification['userId'],
            parentId: payload.parent_id,
            type: payload.type,
            game:
                payload.type === LogNotifyType.NOTIFY_TYPE_GAME
                    ? (payload.sub_type as LogNotifyGame | undefined)
                    : undefined,
            broadcast:
                payload.type === LogNotifyType.NOTIFY_TYPE_BROADCAST
                    ? (payload.sub_type as LogNotifyBroadcast | undefined)
                    : undefined,
            tournament:
                payload.type === LogNotifyType.NOTIFY_TYPE_TOURNAMENT
                    ? (payload.sub_type as LogNotifyTournament | undefined)
                    : undefined,
            payment:
                payload.type === LogNotifyType.NOTIFY_TYPE_PAYMENT
                    ? (payload.sub_type as LogNotifyPayment | undefined)
                    : undefined,
            messageFallback: payload.message_fallback,
            messageData: payload.message_data,
            internal: payload.internal,
            publishedAt: normalizeTimestamp(payload.published_at),
            readAt: normalizeTimestamp(payload.read_at),
        };
    } catch {
        return;
    }
};
